export default __webpack_public_path__ + "static/media/illustration.e5ad9799.png";